module.exports = __webpack_public_path__ + "img/03_scare.23dfd6cc.png";